import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { PartnerCaseNumLookupComponent } from './partner-case-num-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [PartnerCaseNumLookupComponent],
  exports: [PartnerCaseNumLookupComponent],
})
export class PartnerCaseNumLookupModule { }
